"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffsTable = exports.className = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
exports.className = 'tariffs-table';
const TariffsTable = (props) => {
    const { children } = props;
    return (react_1.default.createElement("div", { className: exports.className }, children));
};
exports.TariffsTable = TariffsTable;
//# sourceMappingURL=index.js.map